import {strings} from "@atttomyx/shared-utils";

export const hasCard = (card) => card && strings.isNotBlank(card.type) && strings.isNotBlank(card.last4);
